module.exports = __webpack_public_path__ + "media/images/placeholders/category_corner-57b29bdfdca27bf8d3cc6d6731bbcbd8.svg";